import BaseApiModule from './BaseApiModule'

class LandlordApiModule extends BaseApiModule {
  readonly controller: string
  readonly v2controller: string

  constructor(url: string) {
    super(url)
    this.controller = 'client'
    this.v2controller = 'v2/landlord'
  }

  details(): string {
    const methodUrl = 'details'
    return `${this.baseUrl}/${this.v2controller}/${methodUrl}`
  }

  contact(): string {
    const methodUrl = 'deal'
    return `${this.baseUrl}/${methodUrl}`
  }

  requestOffer(): string {
    const methodUrl = 'deal'
    return `${this.baseUrl}/${methodUrl}`
  }

  downloadBrochure(): string {
    const methodUrl = 'brochure'
    return `${this.baseUrl}/${this.controller}/${methodUrl}`
  }

  getOffer(offerUUID: number): string {
    const methodUrl = 'offer'
    return `${this.baseUrl}/${this.controller}/${methodUrl}/${offerUUID}`
  }
}

export default LandlordApiModule
